import { Variants } from "framer-motion"

export const MainVariants: Variants = {
    'light': {
        color: 'hsl(200, 15%, 8%)',
        backgroundColor: 'hsl(0, 0%, 98%)'
    },
    'dark': {
        backgroundColor: 'hsl(207, 26%, 17%)',
        color: 'hsl(0, 0, 100%)'
    }
}